import styled from "styled-components";

export const TableAction = styled.div`
    display: grid;
    grid-auto-flow: column;
    justify-content: end;
    gap: 0.2rem;
`;
